export default "__VITE_ASSET__BpuBsEk4__"